<template>
  <div class="is-flex" @click="toggle">
    <h1 style="margin-top: 4px;">{{ label }}</h1>
    <div class="switch-container" :class="{'is-active': value}">
      <div class="switch-toggle"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "Switch"
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      let component = this;
      component.$emit("input", !component.value);
    }
  }
};
</script>
<style lang="scss" scoped>
.switch-container {
  $borderRadius: 4px;
  display: flex;
  width: 60px;
  height: 100%;
  border: 1px solid $grey-lighter;
  margin-left: 8px;
  border-radius: $borderRadius;
  background: $grey-lighter;
  cursor: pointer;
  .switch-toggle {
    width: 30px;
    height: calc(100% - 2px);
    margin: 1px;
    background: white;
    border-radius: $borderRadius;
  }
  &.is-active {
    justify-content: flex-end;
    background-color: $success;
  }
}
</style>